// Formats a dosing difference for display: positive values get a leading "+"
// (negatives already carry their own "-"), zero stays bare, and null renders as
// the given placeholder. Kept in one place so the dosing tables stay consistent.
export const formatDifference = (value: number | null, placeholder = '-'): string => {
  if (value == null) return placeholder

  return value > 0 ? `+${value}` : `${value}`
}
